<template>
    <div>
        <div class="page-tabs-box">
            <el-tabs v-model="activeName" @tab-click="reset">
                <el-tab-pane label="初审" name="1"></el-tab-pane>
                <el-tab-pane label="复审" name="2"></el-tab-pane>
            </el-tabs>
        </div>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.queryValue" class="input-with-select" size="small">
                        <el-select v-model="params.queryType" slot="prepend" placeholder="请选择">
                            <el-option label="演出ID" :value="1"></el-option>
                            <el-option label="演出名称" :value="2"></el-option>
                        </el-select>
                    </el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.status" placeholder="请选择" size="small">
                        <el-option v-if="activeName == '1'" label="仅看待初审的" :value="0"></el-option>
                        <el-option v-if="activeName == '2'" label="仅看待复审的" :value="1"></el-option>
                        <el-option label="仅看已通过的" :value="2"></el-option>
                        <el-option label="仅看已拒绝的" :value="3"></el-option>
						<el-option label="仅看已撤销的" :value="4"></el-option>
                        <el-option label="不限制状态" value=""></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column prop="status" label="状态">
                    <template slot-scope="scope">
                        <div :class="status[scope.row.status].class">
                            {{status[scope.row.status].text}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="activityId" label="演出ID"></el-table-column>
                <el-table-column prop="activityName" label="演出名称" min-width="200" show-overflow-tooltip></el-table-column>
                <el-table-column prop="userType" label="申请人身份" min-width="90">
                    <template slot-scope="scope">
                        {{$userType.get(scope.row.userType)}}
                    </template>
                </el-table-column>
                <el-table-column prop="userName" label="申请人姓名" show-overflow-tooltip min-width="90"></el-table-column>
                <el-table-column prop="applyTime" label="申请时间" min-width="150"></el-table-column>
                <el-table-column prop="checkUserName" label="初审人" show-overflow-tooltip></el-table-column>
                <el-table-column prop="checkTime" label="初审时间" min-width="150"></el-table-column>
                <el-table-column prop="recheckUserName" label="复审人" show-overflow-tooltip></el-table-column>
                <el-table-column prop="recheckTime" label="复审时间" min-width="150"></el-table-column>
                <el-table-column fixed="right" label="操作" width="180">
                    <template slot-scope="scope">
                        <template v-if="$utils.have('/activity/cancel/applyDetail')">
                            <el-button
                                v-if="scope.row.status == 0"
                                type="text"
                                size="small"
                                @click="$refs.auditDetail.show(scope.row.id)"
                                >初审</el-button
                            >
                            <el-button
                                v-if="scope.row.status == 1"
                                type="text"
                                size="small"
                                @click="$refs.auditDetail.show(scope.row.id)"
                                >复审</el-button
                            >
                            <el-button
                                v-if="activeName == '1' && scope.row.status != 0 || activeName == '2' && scope.row.status != 1"
                                type="text"
                                size="small"
                                @click="$refs.auditDetail.show(scope.row.id)"
                                >审核进度</el-button
                            >
                        </template>
                        <el-button
                            type="text"
                            size="small"
                            @click="viewActivity(scope.row.activityId)"
                            >查看演出</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>
        <audit-detail ref="auditDetail" @onUpdate="getDataList"></audit-detail>
    </div>
</template>

<script>
import AuditDetail from './components/auditDetail';
const defaultParams = {
    pageNo:1,
    queryType:1,
    queryValue:"",
    status:0
}
export default {
    components:{AuditDetail},
    data(){
        return{
            activeName:"1",
            data: null,
            dataList: null,
            listLoading: true,
            params: {
                ...defaultParams,
                pageSize: this.$pageSizes[0],
            }
        }
    },
    computed:{
        status(){
            return {
                0: {text: "待初审", class: "color-warning"},
                1: {text: "待复审", class: "color-warning"},
                2: {text: "已通过", class: "color-success"},
                3: {text: "已拒绝", class: "color-danger"},
                4: {text: "已撤销", class: "color-info"},
            }
        }
    },
    mounted() {
        this.getDataList();
    },
    methods:{
        getDataList(){
            this.listLoading = true;
            this.params = {
                ...this.params,
            }
            this.$request({
                url: this.activeName == "1" ? "/activity/cancel/checkList" : "/activity/cancel/recheckList",
                method: "POST",
                data: {
                    ...this.params
                },
            })
			.then((res) => {
				const { state, msg, result } = res.data;
				if ( state == 1 && result) {
					this.data = result;
					this.dataList = result.result || [];
				} else {
					this.$message.error(msg || "请求失败");
				}
			})
			.catch(() => {
				this.$message.error("请求错误");
			})
			.finally(() => {
				this.listLoading = false;
			});
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
                status: this.activeName == "1" ? 0 : 1
            };
            this.getDataList();
        },
        //查看演出
        viewActivity(id){
            window.open(`/activityManage/activity/edit/baseInfo/${id}`)
        }
    }
}
</script>

<style lang="scss" scoped>

</style>